import { IconButton, Menu, MenuItem, Stack, Tooltip, Typography } from '@mui/material';
import { Language as LanguageIcon } from '@mui/icons-material';
import { useState } from 'react';
import { useAdminI18n } from '@/contexts/AdminI18nContext';
import type { AdminLanguageCode } from '@/i18n/adminCatalog';

export default function AdminLanguageSelect() {
  const { language, languages, setLanguage, t } = useAdminI18n();
  const [anchorEl, setAnchorEl] = useState<HTMLElement | null>(null);

  const handleSelect = (nextLanguage: AdminLanguageCode) => {
    setLanguage(nextLanguage);
    setAnchorEl(null);
  };

  return (
    <>
      <Tooltip title={t('admin.language.openSelector')}>
        <IconButton
          aria-label={t('admin.language.openSelector')}
          onClick={(event) => setAnchorEl(event.currentTarget)}
          sx={{
            width: 42,
            height: 42,
            border: '1px solid rgba(226, 255, 238, 0.16)',
            bgcolor: 'rgba(244, 255, 249, 0.04)',
          }}
        >
          <LanguageIcon fontSize="small" />
        </IconButton>
      </Tooltip>
      <Menu
        anchorEl={anchorEl}
        open={Boolean(anchorEl)}
        onClose={() => setAnchorEl(null)}
        anchorOrigin={{ vertical: 'bottom', horizontal: 'right' }}
        transformOrigin={{ vertical: 'top', horizontal: 'right' }}
      >
        <Typography variant="caption" color="text.secondary" sx={{ display: 'block', px: 2, py: 1, fontWeight: 800 }}>
          {t('admin.language.title')}
        </Typography>
        {languages.map((option) => {
          const selected = option.code === language;

          return (
            <MenuItem key={option.code} selected={selected} onClick={() => handleSelect(option.code)}>
              <Stack spacing={0.25}>
                <Typography variant="body2">{option.nativeLabel}</Typography>
                <Typography variant="caption" color="text.secondary">
                  {option.label}
                </Typography>
              </Stack>
            </MenuItem>
          );
        })}
      </Menu>
    </>
  );
}
